import React from "react";
import { t } from "i18next";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (this.props.onError) {
      this.props.onError(error, info);
    } else {
      console.error("UI crashed:", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{ padding: 24 }}>
          <h3>{t("errorBoundary.title", { defaultValue: "Something went wrong." })}</h3>
          <p>
            {t("errorBoundary.description", {
              defaultValue: "Please go back to the home page and try again.",
            })}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
